<div class="text-lg text-gray-600 font-bold mobile:mt-2">Info & Tickets</div>
<div class="info-ticket max-h-[50%] min-h-[30%] flex-col items-center py-4 mobile:pb-0"
  [class.!py-2]="!eventService.isNormalTicketUri(event)&&event?.ticketInfo?.length>=2&&settings.toggle.tripPlanner">

  <ng-container *ngIf="!event.isHideTicketUrl&&settings.toggle.eventTicketUrl">
    <div *ngIf="eventService.isNormalTicketUri(event)" class="flex mb-2 gap-2 items-center cursor-pointer"
      (click)="eventService.openTicketUrl(event.ticketUri)" matTooltip="Go to ticket website">
      <div class="p-1 rounded-full bg-gradient-to-r from-[#8ad0ff] to-[#41abf3] hover:shadow-md">
        <ig-image class="flex w-[18px] h-[18px]" cls=""
          src="https://iti-images.s3.amazonaws.com/imgs/ticket+(1)+(1).png"></ig-image>
      </div>
      <a class="ellipsis text-sm">{{eventService.processedTicketUri(event.ticketUri)}}</a>
    </div>
    <div *ngIf="!eventService.isNormalTicketUri(event)&&event?.ticketInfo?.length">
      <div *ngFor="let e of event.ticketInfo.slice(0, 2)" class="flex mb-2 gap-2 items-center cursor-pointer"
        (click)="eventService.openTicketUrl(e.link)" matTooltip="Go to ticket website">
        <div class="p-1 rounded-full bg-gradient-to-r from-[#8ad0ff] to-[#41abf3] hover:shadow-md">
          <ig-image class="flex w-[18px] h-[18px]" cls=""
            src="https://iti-images.s3.amazonaws.com/imgs/ticket+(1)+(1).png"></ig-image>
        </div>
        <!-- <a class="ellipsis text-sm">{{e.source.replace('www.', '')}}</a> -->
        <a class="ellipsis text-sm">{{extractMainDomain(e.link)}}</a>
      </div>
    </div>
  </ng-container>

  <div class="flex justify-between">
    <div class="flex mb-2 gap-2 items-center cursor-pointer" (click)="eventService.visitWebsite(event)"
      matTooltip="View event website">
      <ig-image class="block w-[26px] h-[26px]" cls=""
        src="https://iti-images.s3.amazonaws.com/imgs/info.png"></ig-image>
      <a class="ellipsis text-sm">View website</a>
    </div>
  </div>
</div>